"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportMenu = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var core_api_2 = require("@ikegps/core-api");
var image_button_1 = require("../../components/button/image.button");
var icons_1 = require("../../components/icon/icons");
var menu_1 = require("../../components/menu/menu");
var menu_item_1 = require("../../components/menu/menu.item");
var mithril_component_1 = require("../../components/mithril.component");
var modal_service_1 = require("../../components/modal/modal.service");
var spinner_1 = require("../../components/spinner/spinner");
var theme_1 = require("../../components/theme");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var index_1 = require("../../services/index");
var page_state_1 = require("../../state/page.state");
var ReportMaker_1 = require("../report/ReportMaker");
var export_menu_ctrl_1 = require("./export.menu.ctrl");
var ExportMenu = /** @class */ (function (_super) {
    tslib_1.__extends(ExportMenu, _super);
    function ExportMenu(state) {
        var _this = _super.call(this) || this;
        _this.state = state;
        _this.menu = new menu_1.MenuComponent({
            items: function () { return _this.viewDownloadItems(); }
        });
        return _this;
    }
    Object.defineProperty(ExportMenu.prototype, "nodes", {
        get: function () {
            if (this.state.exporting || !page_state_1.CurrentState.Tag.ready) {
                return spinner_1.Spinner.view();
            }
            var userProfile = index_1.Services.UserProfile.get(index_1.Services.User.current.objectId);
            if (!index_1.Services.UserProfile.canExportReports(userProfile)) {
                return image_button_1.ImageButton.view(icons_1.MaterialIcon.FILE_DOWNLOAD, {
                    title: i18n_1.T.EXPORT_MENU_TITLE_PERMISSION,
                    disabled: true
                });
            }
            if (page_state_1.CurrentState.CollectionEdit.isDirty) {
                return image_button_1.ImageButton.view(icons_1.MaterialIcon.FILE_DOWNLOAD, {
                    title: i18n_1.T.EXPORT_MENU_TITLE_DIRTY,
                    disabled: true
                });
            }
            if (page_state_1.CurrentState.Tag.collections.length > core_api_1.CollectionExportPolicy.MAX_LIMIT) {
                return image_button_1.ImageButton.view(icons_1.MaterialIcon.FILE_DOWNLOAD, {
                    title: i18n_1.T.EXPORT_MENU_TITLE_LIMIT,
                    titleAttrs: { limit: core_api_1.CollectionExportPolicy.MAX_LIMIT },
                    disabled: true
                });
            }
            return (0, mithril_1.m)('div', [
                image_button_1.ImageButton.view(icons_1.MaterialIcon.FILE_DOWNLOAD, {
                    title: i18n_1.T.EXPORT_MENU_TITLE,
                    onclick: this.menu.show
                }),
                this.menu.view()
            ]);
        },
        enumerable: false,
        configurable: true
    });
    ExportMenu.prototype.viewDownloadItems = function () {
        var _this = this;
        var oneCollectionSelected = page_state_1.CurrentState.Tag.collections.length === 1;
        var tagsSelected = Boolean(page_state_1.CurrentState.Tag.tags.length);
        var canReportShort = index_1.Services.Token.has(core_api_2.IkeToken.FEATURE_REPORT_SHORT);
        var hasReportCompositePhoto = index_1.Services.Token.has(core_api_2.IkeToken.FEATURE_REPORT_COMPOSITE_PHOTO) || index_1.Services.Token.has(core_api_2.IkeToken.FEATURE_GROUP_IKE_ANALYZE);
        var hasReportCompositePhotoOnly = index_1.Services.Token.has(core_api_2.IkeToken.FEATURE_REPORT_COMPOSITE_ONLY);
        var hasReportPhoto = index_1.Services.Token.has(core_api_2.IkeToken.FEATURE_REPORT_PHOTO) || index_1.Services.Token.has(core_api_2.IkeToken.FEATURE_GROUP_IKE_ANALYZE);
        // This ensures that all collections have the same form revision which is required for importing excel
        var canExportImportableExcel = page_state_1.CurrentState.Tag.collections.every(function (collectionSummery) { return collectionSummery.formRevision === page_state_1.CurrentState.Tag.collections[0].formRevision; }) && index_1.Services.Token.hasAll([core_api_2.IkeToken.FEATURE_IMPORT_CSV, core_api_2.IkeToken.FEATURE_IMPORT_EXCEL]);
        return [
            {
                visible: tagsSelected,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_KML)),
                action: function () { return export_menu_ctrl_1.ExportMenuController.runExport(_this.state, function () { return export_menu_ctrl_1.ExportMenuController.exportKML(); }); }
            }, {
                visible: tagsSelected,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXCEL)),
                action: function () { return export_menu_ctrl_1.ExportMenuController.runExport(_this.state, function () { return export_menu_ctrl_1.ExportMenuController.exportExcel(); }); }
            }, {
                visible: canExportImportableExcel,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.IMPORTABLE_EXCEL)),
                action: function () { return export_menu_ctrl_1.ExportMenuController.runExport(_this.state, function () { return tslib_1.__awaiter(_this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, export_menu_ctrl_1.ExportMenuController.exportImportableExcel()];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                }); }); }); }
            }, {
                visible: tagsSelected,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_JSON)),
                action: function () { return export_menu_ctrl_1.ExportMenuController.runExport(_this.state, function () { return export_menu_ctrl_1.ExportMenuController.exportJSON(); }); }
            }, {
                visible: tagsSelected,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_REPORT)),
                action: function () { return export_menu_ctrl_1.ExportMenuController.runExport(_this.state, function () { return _this.exportPDF(ReportMaker_1.ReportType.Report, i18n_1.T.EXPORT_REPORT); }); }
            }, {
                visible: tagsSelected && canReportShort,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_REPORT_SHORT)),
                action: function () { return export_menu_ctrl_1.ExportMenuController.runExport(_this.state, function () { return _this.exportPDF(ReportMaker_1.ReportType.ReportShort, i18n_1.T.EXPORT_REPORT_SHORT); }); }
            }, {
                visible: tagsSelected && hasReportCompositePhoto,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_REPORT_COMPOSITE_PHOTO)),
                action: function () { return export_menu_ctrl_1.ExportMenuController.runExport(_this.state, function () { return _this.exportPDF(ReportMaker_1.ReportType.ReportCompositePhoto, i18n_1.T.EXPORT_REPORT_COMPOSITE_PHOTO); }); }
            }, {
                visible: tagsSelected && hasReportCompositePhotoOnly,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_REPORT_COMPOSITE_PHOTO_ONLY)),
                action: function () { return export_menu_ctrl_1.ExportMenuController.runExport(_this.state, function () { return _this.exportPDF(ReportMaker_1.ReportType.ReportCompositePhotoOnly, i18n_1.T.EXPORT_REPORT_COMPOSITE_PHOTO_ONLY); }); }
            }, {
                visible: tagsSelected && hasReportPhoto,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_REPORT_PHOTO)),
                action: function () { return export_menu_ctrl_1.ExportMenuController.runExport(_this.state, function () { return _this.exportPDF(ReportMaker_1.ReportType.ReportPhoto, i18n_1.T.EXPORT_REPORT_PHOTO); }); }
            }, {
                visible: tagsSelected && export_menu_ctrl_1.ExportMenuController.hasOCalcForm(page_state_1.CurrentState.Tag.collections),
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_O_CALC)),
                action: function () { return export_menu_ctrl_1.ExportMenuController.runExport(_this.state, function () { return export_menu_ctrl_1.ExportMenuController.exportOCalc(); }); }
            }, {
                visible: tagsSelected && export_menu_ctrl_1.ExportMenuController.hasSPIDACalcForm(page_state_1.CurrentState.Tag.collections),
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_SPIDA_CALC)),
                action: function () { return export_menu_ctrl_1.ExportMenuController.runExport(_this.state, function () { return export_menu_ctrl_1.ExportMenuController.exportSPIDACalc(false); }); }
            },
            {
                visible: tagsSelected && export_menu_ctrl_1.ExportMenuController.hasSPIDACalcForm(page_state_1.CurrentState.Tag.collections),
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_SPIDA_CALC_NO_PHOTO)),
                action: function () { return export_menu_ctrl_1.ExportMenuController.runExport(_this.state, function () { return export_menu_ctrl_1.ExportMenuController.exportSPIDACalc(true); }); }
            },
            {
                visible: tagsSelected && export_menu_ctrl_1.ExportMenuController.hasPoleforeman(page_state_1.CurrentState.Tag.collections),
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_POLEFOREMAN)),
                action: function () { return export_menu_ctrl_1.ExportMenuController.runExport(_this.state, function () { return export_menu_ctrl_1.ExportMenuController.exportPoleforeman(); }); }
            },
            {
                visible: tagsSelected && export_menu_ctrl_1.ExportMenuController.hasIkePoleForeman(page_state_1.CurrentState.Tag.collections),
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_IKE_POLEFOREMAN)),
                action: function () { return export_menu_ctrl_1.ExportMenuController.runExport(_this.state, function () { return export_menu_ctrl_1.ExportMenuController.exportIkePoleForeman(); }); }
            },
            {
                visible: oneCollectionSelected,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_IMAGE_ZIP)),
                action: function () { return export_menu_ctrl_1.ExportMenuController.runExport(_this.state, function () { return export_menu_ctrl_1.ExportMenuController.exportImageZip(); }); }
            }
        ];
    };
    ExportMenu.prototype.exportPDF = function (type, reportNameTranslationKey) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        modal_service_1.ModalService.open({
                            title: (0, i18n_1.Translate)(i18n_1.T.EXPORTING_PDF_TITLE), content: (0, mithril_1.m)('div', {}, [
                                (0, mithril_1.m)('div', { style: { marginBottom: theme_1.DefaultTheme.space(2) } }, (0, i18n_1.Translate)(i18n_1.T.EXPORTING_PDF_CONTENT)),
                                spinner_1.Spinner.view()
                            ]),
                            hasCancel: false,
                            actions: function () { return; }
                        });
                        return [4 /*yield*/, index_1.Services.Department.rest.Department.User.isLicensed(null)];
                    case 1:
                        result = _a.sent();
                        if (!result.results) return [3 /*break*/, 3];
                        return [4 /*yield*/, export_menu_ctrl_1.ExportMenuController.exportReport(type)];
                    case 2:
                        (_a.sent()).download("".concat((0, i18n_1.Translate)(reportNameTranslationKey), " ").concat(new Date().toDateString()), function () { return modal_service_1.ModalService.close(); });
                        return [3 /*break*/, 4];
                    case 3:
                        index_1.Services.License.hasNoLicense = true;
                        modal_service_1.ModalService.close();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return ExportMenu;
}(mithril_component_1.IMithrilComponent));
exports.ExportMenu = ExportMenu;
//# sourceMappingURL=export.menu.js.map